export const CANONICAL_UI_LOCALES = [
  'en',
  'ar',
  'de',
  'es',
  'fr',
  'hi',
  'it',
  'ja',
  'ko',
  'pl',
  'pt-BR',
  'ru',
  'th',
  'tr',
  'uk',
  'vi',
  'zh',
];

export const LEGACY_UI_LOCALE_ALIASES = {
  'ja-JP': 'ja',
  jp: 'ja',
  pt: 'pt-BR',
  'pt-PT': 'pt-BR',
  'zh-CN': 'zh',
  'zh-Hans': 'zh',
  'zh-SG': 'zh',
  'zh-TW': 'zh',
  'zh-Hant': 'zh',
  'zh-HK': 'zh',
  'zh-MO': 'zh',
};

export const SUPPORTED_I18N_LANGUAGE_CODES = [
  ...CANONICAL_UI_LOCALES,
  ...Object.keys(LEGACY_UI_LOCALE_ALIASES),
];

const CANONICAL_SET = new Set(CANONICAL_UI_LOCALES);
const ALIAS_LOOKUP = Object.entries(LEGACY_UI_LOCALE_ALIASES).reduce((acc, [alias, locale]) => {
  acc[alias.toLowerCase()] = locale;
  return acc;
}, {});

export function normalizeI18nLanguage(language, fallback = 'en') {
  if (!language || typeof language !== 'string') return fallback;

  const normalized = language.replace('_', '-');
  const exactAlias = ALIAS_LOOKUP[normalized.toLowerCase()];
  if (exactAlias) return exactAlias;

  const exactCanonical = CANONICAL_UI_LOCALES.find(locale => locale.toLowerCase() === normalized.toLowerCase());
  if (exactCanonical) return exactCanonical;

  const baseLanguage = normalized.split('-')[0];
  const baseAlias = ALIAS_LOOKUP[baseLanguage.toLowerCase()];
  if (baseAlias) return baseAlias;

  return CANONICAL_SET.has(baseLanguage) ? baseLanguage : fallback;
}

export function normalizeFormatterLocale(language, fallback = 'en') {
  const canonical = normalizeI18nLanguage(language, fallback);

  if (canonical === 'ja') return 'ja';
  if (canonical === 'pt-BR') return 'pt-BR';
  if (canonical === 'zh') return 'zh-CN';

  return canonical;
}

export function normalizeHtmlLanguage(language, fallback = 'en') {
  return normalizeFormatterLocale(language, fallback);
}

export function normalizeAntdLocaleKey(language, fallback = 'en') {
  return normalizeI18nLanguage(language, fallback);
}

export function getUrlLanguageParam(language) {
  const canonical = normalizeI18nLanguage(language);
  return canonical === 'en' ? null : canonical;
}

export function isSupportedI18nLanguage(language) {
  return SUPPORTED_I18N_LANGUAGE_CODES.includes(language);
}
